import { get } from 'lodash-es'

import STORE_CONSTANTS from '../utils/store-constants'

export const byId = (state, id) => get(state, [STORE_CONSTANTS.BY_ID, id], undefined)
export const allById = (state, id = '') => get(state, [id, STORE_CONSTANTS.BY_ID], undefined)
export const allIds = state => get(state, STORE_CONSTANTS.ALL_IDS, [])
